module.exports = __webpack_public_path__ + "img/operate_complaint.ce770e68.png";